export default __webpack_public_path__ + "static/media/Group10.3547473b.png";